import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { LanguageProvider } from "@/context/LanguageContext";
import { AdminAuthProvider } from "@/context/AdminAuthContext";
import { AccountAuthProvider } from "@/context/AccountAuthContext";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import Carnet from "@/pages/Carnet";
import Booking from "@/pages/Booking";
import Membership from "@/pages/Membership";
import KidsCamp from "@/pages/KidsCamp";
import Workshops from "@/pages/Workshops";
import SpecialEvents from "@/pages/SpecialEvents";
import Account from "@/pages/Account";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminDashboard from "@/pages/admin/AdminDashboard";

function ScrollManager() {
  const location = useLocation();
  useEffect(() => {
    if (location.state?.scrollTo) {
      const el = document.getElementById(location.state.scrollTo);
      if (el) {
        setTimeout(() => el.scrollIntoView({ behavior: "smooth" }), 100);
        return;
      }
    }
    window.scrollTo(0, 0);
  }, [location]);
  return null;
}

function Shell() {
  const location = useLocation();
  const isAdmin = location.pathname.startsWith("/admin");

  if (isAdmin) {
    return (
      <AdminAuthProvider>
        <Routes>
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminDashboard />} />
        </Routes>
      </AdminAuthProvider>
    );
  }

  return (
    <LanguageProvider>
      <AccountAuthProvider>
        <ScrollManager />
        <Header />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/carnet" element={<Carnet />} />
            <Route path="/reservation" element={<Booking />} />
            <Route path="/adhesion" element={<Membership />} />
            <Route path="/kids-camp" element={<KidsCamp />} />
            <Route path="/ateliers" element={<Workshops />} />
            <Route path="/evenements" element={<SpecialEvents />} />
            <Route path="/mon-compte" element={<Account />} />
          </Routes>
        </main>
        <Footer />
      </AccountAuthProvider>
    </LanguageProvider>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Shell />
      </BrowserRouter>
    </div>
  );
}

export default App;
